<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Partners List">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-between pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-template
                  (keyup)="applyFilter()"
                  [inputData]="attrConstant.search"
                  [formControlName]="
                    attrConstant.search.key
                  "></app-input-template>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
              <div class="d-flex align-items-center gap-10">
                <img
                  src="assets/images/reload.svg"
                  alt="reload"
                  class="reload-img"
                  matTooltip="Reload"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="reload()" />
                <button class="btn primary-btn" (click)="export()">
                  Export
                </button>
              </div>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Id Column -->
              <ng-container matColumnDef="partner_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
                <td mat-cell *matCellDef="let element" data-label="Id">
                  {{ element.partner_id }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element" data-label="Name">
                  {{ element.name }}
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element" data-label="Email">
                  {{ element.email }}
                </td>
              </ng-container>

              <!-- Mode Column -->
              <ng-container matColumnDef="mode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mode</th>
                <td mat-cell *matCellDef="let element" data-label="Mode">
                  {{ element.mode }}
                </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Created Date
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Created Date">
                  {{ element.created_at | date: 'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <!-- Is Active Column -->
              <ng-container matColumnDef="is_active">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container *appHasAccess="'update-partner-status'">
                    Is Active
                  </ng-container>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Action"
                  (click)="$event.stopPropagation()">
                  <mat-slide-toggle
                    *appHasAccess="'update-partner-status'"
                    [checked]="element.is_active"
                    (change)="onToggle($event, element)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container *appHasAccess="'/partner/edit/:id'">
                    Action
                  </ng-container>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Action"
                  (click)="$event.stopPropagation()">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      [ngClass]="element.is_active ? 'enabled' : 'disabled'"
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="right"
                      [routerLink]="['/partner/edit', element.partner_id]"
                      *appHasAccess="'/partner/edit/:id'" />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="onDeletePartner(element)"
                      *appHasAccess="'delete-partner'" />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="let row; columns: displayedColumns; let element"
                [routerLink]="['/partner/details', element.partner_id]"></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)"></mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'/partner/add'">
        <ng-template mat-tab-label>
          <a [routerLink]="['/partner/add']" class="btn primary-btn">
            Register Partner
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
